import { Service } from '@toeverything/infra';

import { QuotaCheckDialog } from '../entities/quota-check-dialog';

export class QuotaCheckDialogService extends Service {
  dialog = this.framework.createEntity(QuotaCheckDialog);
}
